import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BookingsComponent } from './bookings/bookings.component';
import { BookingsListComponent } from './bookings-list/bookings-list.component';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';
import { BookingsModifyComponent } from './bookings-modify/bookings-modify.component';
import { BookingTransactionHistoryComponent } from '../bookings/booking-transaction-history/booking-transaction-history.component';

const routes: Routes = [
  {
    path: 'bookings', component: BookingsComponent, canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', component: BookingsListComponent},
      { path: 'add', component: BookingsModifyComponent},
      { path: 'edit/:id', component: BookingsModifyComponent} ,
      { path: 'edit/:id/bookingTransaction/:transId', component: BookingTransactionHistoryComponent, },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookingsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/bookings/bookings-routing.module.ts